var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid main-content"},[_c('div',{staticClass:"main-panel"},[_c('div',{class:'content-wrapper ' + _vm.paddingClass},[_c('div',{staticClass:"inner-div"},[_c('router-view')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }